import { AnyAction } from 'redux';
import {
    GET_UNITS_FAILURE,
    GET_UNITS_REQUEST,
    GET_UNITS_SUCCESS,
    ADD_UNITS_FAILURE,
    ADD_UNITS_REQUEST,
    ADD_UNITS_SUCCESS,
    DELETE_UNITS_REQUEST,
    DELETE_UNITS_SUCCESS,
} from '../constants/units.constants';

const initialState = {
    loading: false,
    data: [],
    error: '',
    unit: {},
    unitsLoading: false,
};

const unitsReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        // Get Units Actions
        case GET_UNITS_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case GET_UNITS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: '',
            };
        case GET_UNITS_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };

        // Add Units Actions
        case ADD_UNITS_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case ADD_UNITS_SUCCESS:
            return {
                ...state,
                unit: action.payload,
                loading: false,
                // data: action.payload,
                error: '',
            };
        case ADD_UNITS_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };
        case DELETE_UNITS_REQUEST:
            return {
                ...state,
                unitsLoading: true,
            };
        case DELETE_UNITS_SUCCESS:
            return {
                ...state,
                unitsLoading: false,
            };
        default:
            return state;
    }
};

export default unitsReducer;
